module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Bold-7dbe19ded7ff46c0763b218844f786ef.otf";